module.exports = __webpack_public_path__ + "img/grPdt01.0c0a789b.jpg";